import { singularOrPlural } from 'utils/common';
import { ASSET_PREFIX, PaymentSchedule } from 'utils/constants';
import styles from './OrderSummaryRows.module.css';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { getNumberOfTreesPlanted } from 'components/enter/helpers/getNumberOfTreesPlanted';
import { EntryMethod } from 'components/enter/EntryMethod';
import { observer } from 'mobx-react-lite';

export interface Props {
  showDays: boolean;
}

const OrderSummaryRows = observer((props: Props) => {
  const { days, dayEnabled, entryMethod, lines, boosted, paymentSchedule } =
    useEnterStore();
  const numberOfTreesPlantedPerWeek = getNumberOfTreesPlanted(
    entryMethod,
    dayEnabled.TUESDAY,
    dayEnabled.FRIDAY,
  );

  const rows: string[][] = [];

  rows.push([
    `${ASSET_PREFIX}/images/ticket.svg`,
    lines.length +
      ' ' +
      singularOrPlural(lines.length, 'entry', 'entries') +
      ' per draw',
  ]);

  if (props.showDays) {
    rows.push([
      `${ASSET_PREFIX}/images/enter/calendar-icon.svg`,
      days.length +
        singularOrPlural(days.length, ' draw', ' draws') +
        ' (' +
        days
          .map(
            (day) => day.charAt(0).toUpperCase() + day.slice(1).toLowerCase(),
          )
          .join(' & ') +
        ')',
    ]);
  }

  rows.push([
    `${ASSET_PREFIX}/images/common/trees-planted-solid-icon.svg`,
    (numberOfTreesPlantedPerWeek === 1
      ? '1 tree planted'
      : `${numberOfTreesPlantedPerWeek} trees planted`) +
      (entryMethod !== EntryMethod.OneOff
        ? ` per ${
            paymentSchedule === PaymentSchedule.MONTHLY ? 'month' : 'week'
          }`
        : ''),
  ]);

  if (boosted) {
    rows.push([`${ASSET_PREFIX}/images/enter/rocket.png`, 'Boosted jackpot']);
  }

  return (
    <div className={styles.container + ' aboutUsTypographyBodySmall'}>
      {rows.map((x, i) => (
        <div key={i}>
          <img className={styles.rowIcon} src={x[0]} alt="" />
          {x[1]}
        </div>
      ))}
    </div>
  );
});

export default OrderSummaryRows;
